<template>
  <div>
    <Header />
    <div class="dash-body">
      <div class="dash-header">
        <div class="dash-caption reports-page">
          {{ $t('REPORTS_REPORT') }}
        </div>
        <div class="dash-options">
          <calendar :callback="setPage" />
        </div>
      </div>
      <div class="p-list reports-tab">
        <div v-if="!getReports || getReports.length === 0" class="no-reports-placeholder">
          <p class="no-reports-text">{{ $t('REPORTS_NO_REPORTS_YET') }}</p>
        </div>
        <table v-else>
          <tbody>
            <tr :key="index" v-for="(report, index) in getReports">
              <td>{{ report.type }}</td>
              <td>
                {{ $t('REPORTS_LIST') }} 
                <span v-for="(page, pIdx) in getReportPages(report)" :key="'p'+pIdx">
                  <a :href="page.url" target="_blank" :title="page.fullName">{{ page.displayName }}</a><template v-if="pIdx < getReportPages(report).length - 1">, </template>
                </span>
                {{ $t('REPORTS_LIST_PRD') }} 
                <b
                  >{{ moment(report.from).format("YYYY-MM-DD") }} -
                  {{ moment(report.to).format("YYYY-MM-DD") }}</b
                >
                {{ $t('REPORTS_WAS') }} 
                <b>{{ moment(report.date).format("YYYY-MM-DD, HH:mm") }}</b>
              </td>
              <td
                class="reports-export"
                @click="download(report.hash_id, report.type)"
              >
                {{ $t('REPORTS_DOWNLD') }} 
              </td>
              <td>
                <span
                  class="close"
                  @click="DELETE_REPORT({ id: report.id, type: report.type })"
                  ><i class="bi bi-x-lg"></i></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- отчёты контент-мониторинга (текст / картинки): живут в CM API, не в reports Lucmus -->
      <div class="dash-header">
        <div class="dash-caption reports-page">{{ $t('CM_REPORTS_TITLE') }}</div>
      </div>
      <div class="p-list reports-tab">
        <div v-if="cmError" class="no-reports-placeholder">
          <p class="no-reports-text">{{ cmError }}</p>
        </div>
        <div v-else-if="!cmReports.length" class="no-reports-placeholder">
          <p class="no-reports-text">{{ $t('REPORTS_NO_REPORTS_YET') }}</p>
        </div>
        <table v-else>
          <tbody>
            <tr v-for="report in cmReports" :key="report.hash">
              <td>{{ report.type }}</td>
              <td>
                <b>{{ $t(cmFormatKey(report.format)) }}</b> ·
                {{ $t('REPORTS_LIST') }}
                <span :title="report.names">{{ shortNames(report.names) }}</span>
                {{ $t('REPORTS_LIST_PRD') }}
                <b>{{ report.date_from }} - {{ report.date_to }}</b>
                {{ $t('REPORTS_WAS') }}
                <b>{{ moment.utc(report.created_at).local().format("YYYY-MM-DD, HH:mm") }}</b>
              </td>
              <td class="reports-export" @click="downloadCm(report)">
                {{ $t('REPORTS_DOWNLD') }}
              </td>
              <td>
                <span class="close" @click="deleteCm(report)"><i class="bi bi-x-lg"></i></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Calendar from "../components/Calendar";
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  REPORTS_GET,
  REPORTS_DOWNLOAD,
  DELETE_REPORT,
} from "../store/actions/reports";
import {
  INTRO_SET_PAGES,
  INTRO_SET_PERIOD,
} from "../store/actions/intro";
import cmApi from "@/api/controllers/content-monitoring";
import { saveBlob } from "@/models/content-monitoring/save-blob";

export default {
  name: "ReportsList",
  components: {
    Header,
    Calendar,
  },
  data() {
    return { cmReports: [], cmError: "" };
  },
  computed: {
    ...mapGetters(["getSelectedPages", "getPeriod", "getReports", "getPages", "isPagesLoaded"]),
  },
  methods: {
    loadCm() {
      this.cmError = "";
      return cmApi
        .fetchReports()
        .then((rows) => { this.cmReports = rows; })
        .catch((e) => { this.cmError = e.message || String(e); });
    },
    cmFormatKey(format) {
      return format === "media" ? "CM_FORMAT_MEDIA" : format === "all" ? "CM_FORMAT_ALL" : "CM_FORMAT_TEXT";
    },
    shortNames(names) {
      const s = String(names || "");
      return s.length > 60 ? s.substring(0, 60) + "…" : s;
    },
    downloadCm(report) {
      cmApi
        .downloadReport(report.hash)
        .then(({ blob, filename }) => saveBlob(blob, filename))
        .catch((e) => this.$alert.show({ message: e.message || String(e), type: "global", color: "black" }));
    },
    deleteCm(report) {
      cmApi
        .deleteReport(report.hash)
        .then(() => { this.cmReports = this.cmReports.filter((r) => r.hash !== report.hash); })
        .catch((e) => this.$alert.show({ message: e.message || String(e), type: "global", color: "black" }));
    },
    ...mapMutations([INTRO_SET_PERIOD]),
    ...mapActions([
      REPORTS_GET,
      REPORTS_DOWNLOAD,
      DELETE_REPORT,
      INTRO_SET_PAGES,
    ]),
    setPage() {
      this.REPORTS_GET();
    },
    getReportPages(report) {
      const names = Array.isArray(report.names)
        ? report.names
        : (report.names || '').split(',').map(n => n.trim());

      const pages = this.getPages || [];
      return names.filter(name => name).map(name => {
        const match = pages.find(p => p.fullowner_name === name || p.owner_name === name);
        const fullName = name;
        return {
          fullName,
          displayName: fullName.length > 25 ? fullName.substring(0, 25) + '...' : fullName,
          url: match ? match.owner_url : '/',
        };
      });
    },
    download: function (hashId, type) {
      this.$store.dispatch(REPORTS_DOWNLOAD, { hashId, type }).then((response) => {
        if (response.status != 200) return;

        const fileURL = window.URL.createObjectURL(response.data);
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", `file.${type}`);
        fileLink.click();
      });
    },
  },
  async mounted() {
    this.setPage();
    this.loadCm();
    if (!this.isPagesLoaded) {
      if (!this.getPeriod) {
        this.INTRO_SET_PERIOD({
          start: this.moment().subtract(30, "days").format("YYYY-MM-DD"),
          end: this.moment().subtract(1, "days").format("YYYY-MM-DD"),
        });
      }
      await this.INTRO_SET_PAGES();
    }
  },
};
</script>

<style>
</style>